import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
// import GroupIcon from "@mui/icons-material/Group";
// import ApartmentIcon from "@mui/icons-material/Apartment";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
// import SequrityAlertTabel from "./SequrityAlertTabel";
// import DashPieGraph from "./DashPieGraph";
import Event1 from "./Event1";
// import Event2 from "./Event2";
import GuardsTable from "./GuardsTable";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
// import DataTable from "react-data-table-component";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import SequrityAlertSnoozeModal from "./SequrityAlertSnoozeModal";
import RejectRequestModal from "./RejectRequestModal";
import ActivitiesSlider from "./ActivitiesSlider";
// import RequestSlider from "./RequestSlider";
import NoticeBoardAndDiscuTab from "./NoticeBoardAndDiscuTab";
import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import TicketSlider from "./TicketSlider";
// import moment from "moment";

// End

// Service Pro Table
// const columns = [
//   {
//     name: "Service Prov Name",
//     selector: (row) => row.ServiceProviderName,
//   },
//   {
//     name: "Contact No.",
//     selector: (row) => row.ContactNo,
//   },
//   {
//     name: "Service type",
//     selector: (row) => row.Servicetype,
//   },
//   {
//     name: "Time In",
//     selector: (row) => row.TimeIn,
//   },
//   {
//     name: "Time Out",
//     selector: (row) => row.TimeOut,
//   },
// ];

// const data = [
//   {
//     id: 1,
//     ServiceProviderName: "Akshay Dev",
//     ContactNo: "9881789825",
//     Servicetype: "Cleaner",
//     TimeIn: "09:30 am",
//     TimeOut: "06:30 pm",
//   },
//   {
//     id: 2,
//     ServiceProviderName: "Mahesh Joshi",
//     ContactNo: "9881789825",
//     Servicetype: "Cleaner",
//     TimeIn: "09:30 am",
//     TimeOut: "06:30 pm",
//   },
//   {
//     id: 3,
//     ServiceProviderName: "Merry Doe",
//     ContactNo: "9881789825",
//     Servicetype: "Cleaner",
//     TimeIn: "09:30 am",
//     TimeOut: "06:30 pm",
//   },
// ];
// End

function Dashboard() {
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const [openComplCnt, setOpenComplCnt] = React.useState();
  const [closeComplCnt, setCloseComplCnt] = React.useState();
  const [ticketCnt, setTicketCnt] = React.useState();

  async function GetAllComplaints() {
    setShowLoader(true);
    await makeGetRequest("complaint/getCount/")
      .then((response) => {
        if (response.status === 201) {
          if (response.data.data) {
            setOpenComplCnt(response.data.data.openComplaint);
            setCloseComplCnt(response.data.data.closeComplaint);
            setTicketCnt(response.data.data.ticketCnt);
            setShowLoader(false);
          }
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const descriptionElementRef = React.useRef(null);
  // const [lstDashboard, setLstDashboard] = React.useState([]);
  // const [showTickets, setShowTickets] = React.useState(false);
  // const [showComplaints, setComplaints] = React.useState();
  const [showLoader, setShowLoader] = React.useState(false);
  const [sosalert, setsosalert] = React.useState("");

  const handleListItemClick = (event, index) => {
    localStorage.setItem("selectedIndex", index);
    navigate("/Tickets");
    // setUpload(!Upload);
    // setSelectedIndex(index);
  };


 


  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    if (localStorage.getItem("showsos")) {
      let sosval = localStorage.getItem("showsos");
      setsosalert(sosval);
    }
    GetAllComplaints();
    // getAllActiveServiceProviders();
  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={6}>
            <h1 className="panelHeading">Dashboard </h1>
           
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <p className="eventTime blink_me">
              All Resident meeting is at 04:00pm Today.
            </p>
          </Grid> */}
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <div className="countMain">
              <div className="activitiesMain">
                <div className="tableHead">
                  <p className="tableMainHead">Alerts</p>
                  
                </div>
                <div className="activitiesSlideOuter">
                  <ActivitiesSlider />
                </div>
              </div>
            </div>

            <div className="noticeBoardMain">
              <NoticeBoardAndDiscuTab />
            </div>

            <div className="guardNewMain">
              <GuardsTable />
            </div>

          {/* //Div For Service Provider */}
            {/* <div className="serviceProTableMain guardNewMain">
              <DataTable columns={columns} data={data} />
            </div> */}
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="countMain">
              <Grid container spacing={3}>
                {/* {showComplaints? */}
                {sosalert !== "" && (
                  <Grid item xs={12} md={12}>
                    <div className="complaintMain notificationBox">
                      <NotificationsActiveIcon className="complaintIco" />
                      <div className="complaintInner sosOuterDash">
                        <div>
                          <div className="complaintHed">SOS Alert</div>
                          <div className="newSOSDashBo blink_me">
                            {sosalert}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                )}
                <Grid item xs={12} md={12}>
                  <div className="complaintMain">
                    <MarkUnreadChatAltIcon className="complaintIco" />
                    <div className="complaintInner">
                      <div
                        className="complaintHed"
                        onClick={() => navigate("/ComplaintsPage")}
                      >
                        Complaints
                      </div>
                      <div className="complaintCont">
                        <div className="complaintCont1">
                          <div>
                            <b>{openComplCnt}</b>
                            <span>Open</span>
                          </div>
                          <ArrowForwardIosIcon
                            onClick={() => navigate("/ComplaintsPage")}
                          />
                        </div>
                        <div className="devid"></div>
                        <div className="complaintCont1 complaintCont2">
                          <div>
                            <b>{closeComplCnt}</b>
                            <span>Resolved</span>
                          </div>
                          <ArrowForwardIosIcon
                            onClick={() =>
                              navigate("/ComplaintsPage", {
                                state: { selectedTab: 1 },
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                {/* :<></>} */}
                {/* <Grid item xs={12} md={6}>
                  <div className="countDiv">
                    <div className="iconDiv">
                      <MarkUnreadChatAltIcon />
                    </div>
                    <div className="countCont">
                      <h2>1550</h2>
                      <p>Complaints</p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="countDiv">
                    <div className="iconDiv">
                      <ApartmentIcon />
                    </div>
                    <div className="countCont">
                      <h2>2000</h2>
                      <p>Booked Amenities</p>
                    </div>
                  </div>
                </Grid> */}

                {/* <Grid item xs={12} md={12}>
                  <div className="requestNewMain">
                    <div className="requestNewTotal">
                      <div className="totalCountRequest">+5</div>
                      <h4>New Requests</h4>
                    </div>
                    <RequestSlider />
                  </div>
                </Grid> */}
                {/* {(showTickets)? */}
                <Grid item xs={12} md={12}>
                  <div className="requestNewMain">
                    <div
                      className="requestNewTotal"
                      // onClick={() => navigate("/Tickets")}
                      onClick={(event) => handleListItemClick(event, 8)}
                    >
                      <div className="totalCountRequest">{ticketCnt}</div>
                      <h4>New Support Ticket</h4>
                    </div>
                    <TicketSlider />
                  </div>
                </Grid>
                {/* :<></>} */}

                <Grid item xs={12} md={12}>
                  {/* <div className="eventOuter">
                    <div className="tableHead">
                      <p className="tableMainHead">Bookings Requests</p>
                    </div>
                    <div className="eventContent">
                      <div className="bookingReqMain">
                        <h3>Indoor Basketball Court</h3>
                        <div className="dateNtimeDiv">
                          <p>
                            Date - <b>05/09/2022</b>
                          </p>
                          <p>
                            Time - <b> 2pm to 3pm</b>
                          </p>
                        </div>
                        <p className="reqNameTex">
                          Requested by <span>Aniket Parikh (Wing B - 239)</span>
                        </p>
                        <div className="textAproRejBtOut">
                          <p>25/08/2022, 3:54pm</p>
                          <div className="AproRejBtOut">
                            <Button>Approve</Button>{" "}
                            <Button className="rejBt">Reject</Button>
                          </div>
                        </div>
                        <b
                          className="allReqTex"
                          onClick={() => navigate("/PendingAmenities")}
                        >
                          <b>+5</b> New Requests
                        </b>
                      </div>
                    </div>
                  </div> */}

                  <div className="eventOuter weekLim" style={{ marginTop: 0 }}>
                    <div className="tableHead">
                      <p className="tableMainHead">Upcoming Events</p>
                      <div className="dashEventBtns">
                        <Button
                          className="adEvntB"
                          onClick={() => navigate("/AddEvent")}
                        >
                          + Add Event
                        </Button>
                        <Button
                          className="adEvntB"
                          onClick={() => navigate("/ViewEvents")}
                        >
                          All Events
                        </Button>
                      </div>
                    </div>
                    <div className="leftEventDivMain">
                      <Event1 />
                    </div>
                  </div>
                </Grid>

                {/* <Grid item xs={12} md={12}>
                  <div className="eventOuter">
                    <div className="tableHead">
                      <p className="tableMainHead">Upcoming Events</p>
                    </div>
                    <div className="eventContent">
                      <div className="leftEventDivMain">
                        <Event2 />
                      </div>
                      <div className="leftEventDivMain">
                        <Event1 />
                      </div>
                    </div>
                  </div>
                </Grid> */}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Message</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont snoozOuter">
              <div className="">
                <RejectRequestModal />
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* {showLoader ? (
        <div className="loaderOut" id="loaderId">
          <div className="loaderBox">
            <img src={Loader} />
          </div>
        </div>
      ) : (
        <></>
      )} */}

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default Dashboard;
